import { validURL } from "../utils/helper";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      invalidDomains: {
        message: "Domain entered incorrectly.",
        indexList: [],
      },
    };
  },

  computed: {
    ...mapGetters("stores", [
      "selectedStore",
      "groups",
      "storeCategories",
      "isStoreInGroup",
      "isStoreInCategory",
      "storeProviders",
      "status",
      "storeLogo",
      "isGroupInTopList",
      "feedOrUrl",
      "paymentTypes",
      "validationStatus",
      "currentStep",
      "errorMessage",
      "utmTags",
      "showUtmTags",
      "getUrlPlaceholder",
      "urlPlaceholder",
      "providersWithUtmTags",
    ]),
  },

  methods: {
    ...mapActions("stores", [
      "initStore",
      "updateField",
      "toggleGroupConnection",
      "selectEmptyStore",
      "setStoreProviders",
      "setStoreCategories",
      "toggleCategoryConnection",
      "resetStore",
      "saveStore",
      "updateCurrentStep",
      "updateFeedOrUrl",
      "clearWizardForm",
      "clearValidationStatus",
      "isFormValid",
      "selectStore",
      "updateStore",
      "toggleTopList",
    ]),

    ...mapMutations("stores", [
      "setPaymentTypes",
      "setEmptyPaymentTypes",
      "setLogoFile",
      "addDomain",
      "updateDomain",
      "removeDomain",
      "setUtmTags",
      "resetUtmTags",
      "setShowUtmTags",
      "setUrlPlaceholder",
    ]),

    updateDomainHandler({ index, value }) {
      this.updateDomain({ id: index, host: value });
      const isInvalidDomain = !validURL(value);
      if (isInvalidDomain && !this.invalidDomains.indexList.includes(index)) {
        this.invalidDomains.indexList.push(index);
      }
      if (!isInvalidDomain && this.invalidDomains.indexList.includes(index)) {
        this.invalidDomains.indexList = this.invalidDomains.indexList.filter(i => i !== index);
      }
    },

    deleteDomain(index) {
      if (this.invalidDomains.indexList.includes(index)) {
        this.invalidDomains.indexList = this.invalidDomains.indexList.filter(i => i !== index);
      }
      this.removeDomain(index);
    }
  }
}
